import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  PutRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantUserSkillSerializerType = {
  displayName: string;
  experiencePeriodCategoryId: number | null;
  skillStatusTypeId: number | null;
  neighborIds: number[];
};

export type PostTenantUserSkillPayloadType = TenantUserSkillSerializerType;
export type PutTenantUserSkillPayloadType = (
  Partial<TenantUserSkillSerializerType>
);

type GetTenantUserSkillArgsType = GetRequestArgsType & {
  tenantUserId: number;
};
type PostTenantUserSkillArgsType = PostRequestArgsType<PostTenantUserSkillPayloadType> & {
  tenantUserId: number;
};
type PutTenantUserSkillArgsType = PutRequestArgsType<PutTenantUserSkillPayloadType> & {
  tenantUserId: number;
  tenantUserSkillId: number;
};
type DeleteTenantUserArgsType = DeleteRequestArgsType & {
  tenantUserId: number;
  tenantUserSkillId: number;
};

export const apiFetchTenantUserSkills = async ({
  domain = useTenantStore().domain,
  query = {},
  tenantUserId,
  errorConfig = {},
  callbacks = {},
}: GetTenantUserSkillArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.tenantUserSkills({ domain, tenantUserId, tenantUserSkillId: null }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateTenantUserSkill = async ({
  domain = useTenantStore().domain,
  tenantUserId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostTenantUserSkillArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.tenantUserSkills({ domain, tenantUserId, tenantUserSkillId: null }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateTenantUserSkill = async ({
  domain = useTenantStore().domain,
  tenantUserId,
  tenantUserSkillId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PutTenantUserSkillArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.tenantUserSkills({ domain, tenantUserId, tenantUserSkillId }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTenantUserSkill = async ({
  domain = useTenantStore().domain,
  tenantUserId,
  tenantUserSkillId,
  errorConfig = {},
  callbacks = {},
}: DeleteTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.tenantUserSkills({ domain, tenantUserId, tenantUserSkillId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
